__turbopack_context__.v({
  "collapsed": "HeaderMobile-module-scss-module__neYJAq__collapsed",
  "menuWrapper": "HeaderMobile-module-scss-module__neYJAq__menuWrapper",
  "mobileHeaderContainer": "HeaderMobile-module-scss-module__neYJAq__mobileHeaderContainer",
  "mobileHeaderWrapper": "HeaderMobile-module-scss-module__neYJAq__mobileHeaderWrapper",
  "mobileMenuWrapper": "HeaderMobile-module-scss-module__neYJAq__mobileMenuWrapper",
  "subNavigationItem": "HeaderMobile-module-scss-module__neYJAq__subNavigationItem",
  "subNavigationLink": "HeaderMobile-module-scss-module__neYJAq__subNavigationLink",
});
